// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as LastCard$Showside from "../components/LastCard.bs.js";
import * as LCPContext$Showside from "../context/LCPContext.bs.js";
import * as StringUtils$Showside from "../utils/StringUtils.bs.js";
import * as CategoryCard$Showside from "../components/CategoryCard.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function getSmartCard(title, visibleInMenuBarOpt, firstCardOpt, category) {
  var visibleInMenuBar = visibleInMenuBarOpt !== undefined ? visibleInMenuBarOpt : false;
  var firstCard = firstCardOpt !== undefined ? firstCardOpt : false;
  var match = Category$Showside.ExternalConnection.getStoreCategoryConnection(category);
  if (match === undefined) {
    return;
  }
  if (Category$Showside.getChildren(category).length === 0) {
    return;
  }
  var newrecord = Caml_obj.obj_dup(category);
  return newrecord.categoryType = {
    TAG: /* Standard */1,
    _0: {
      firstCard: firstCard ? Category$Showside.getFirstCard(category) : undefined,
      externalConnection: Category$Showside.ExternalConnection.getConnection(category),
      children: [],
      loadMoreChildren: undefined,
      totalChildren: 0,
      link: undefined,
      products: Category$Showside.getProducts(category),
      taggedMedia: Category$Showside.TaggedMedia.get(category),
      imageHotspots: undefined,
      imageWidth: undefined,
      imageHeight: undefined
    }
  }, newrecord.card = Belt_Option.getWithDefault(Category$Showside.getFirstCard(category), category.card), newrecord.visibleInMenuBar = visibleInMenuBar, newrecord.description = undefined, newrecord.title = Belt_Option.getWithDefault(title, "All"), newrecord.id = category.id, newrecord;
}
function use(contentType, activeCategory, layout, enableSmartCardOpt, enableFirstCardOpt, enableLastCardOpt, forcedOpenLink, category) {
  var enableSmartCard = enableSmartCardOpt !== undefined ? enableSmartCardOpt : false;
  var enableFirstCard = enableFirstCardOpt !== undefined ? enableFirstCardOpt : false;
  var enableLastCard = enableLastCardOpt !== undefined ? enableLastCardOpt : false;
  var match = ViewportContext$Showside.use(undefined);
  var match$1 = ConfigurationProvider$Showside.use(undefined).config;
  var category$1 = Belt_Option.getWithDefault(Category$Showside.getCategoryById(match$1.categories, category.id), category);
  var activeCategoryId = Belt_Option.map(activeCategory, function (c) {
    return c.id;
  });
  var storeConnection = Category$Showside.ExternalConnection.getStoreCategoryConnection(category$1);
  var hasSubCats = Category$Showside.hasSubCategories(category$1);
  var isConnected = Belt_Option.isSome(storeConnection);
  var isConnectedWithSubCats = isConnected && hasSubCats;
  var canRenderSmartCard = !match.isMobile && enableSmartCard && enableFirstCard;
  var canRenderFirstCard = (Caml_obj.notequal(category$1.id, activeCategoryId) || contentType === /* Category */0) && enableFirstCard;
  var match$2 = LCPContext$Showside.use(undefined);
  var onMainImageRendered = match$2.onMainImageRendered;
  var match$3 = EntrypointContext$Showside.use(undefined);
  var onSmartCardClick = match$3.onSmartCardClick;
  var onCategoryClick = match$3.onCategoryClick;
  var trackEvent = match$3.trackEvent;
  var forceOpenLinkFirstCard = forcedOpenLink === /* ForceAllCards */0 || forcedOpenLink === /* ForceFirstAndLastCards */1;
  var forceOpenLinkLastCard = forcedOpenLink === /* ForceAllCards */0 || forcedOpenLink === /* ForceFirstAndLastCards */1 || forcedOpenLink === /* ForceLastCards */2;
  var onImageRendered = React.useCallback(function (param) {
    Curry._1(onMainImageRendered, undefined);
  }, []);
  var cardShape = contentType ? Category$Showside.CategoryCard.getCardShape(match$1.settings.productCardShape, [/* Square */1, /* Portrait */3, /* Landscape */2], category$1.card) : Category$Showside.CategoryCard.getCardShape(undefined, undefined, category$1.card);
  var smartCard = React.useMemo(function () {
    return getSmartCard(undefined, undefined, undefined, category$1);
  }, [category$1.id, match$1.lastModifiedAt]);
  var smartCard$1;
  if (smartCard !== undefined && canRenderSmartCard) {
    var newrecord = Caml_obj.obj_dup(category$1);
    smartCard$1 = Caml_option.some(React.createElement(CategoryCard$Showside.make, {
      category: (newrecord.card = Belt_Option.getWithDefault(Category$Showside.getFirstCard(category$1), category$1.card), newrecord.title = StringUtils$Showside.concatWithoutRepeat("All", category$1.title), newrecord),
      id: "" + category$1.id + "-smart-card",
      shape: cardShape,
      forcedOpenLink: forceOpenLinkFirstCard,
      inspectable: "first-card",
      onClick: onSmartCardClick,
      onImageRendered: onImageRendered,
      key: "" + category$1.id + "-smart-card"
    }));
  } else {
    smartCard$1 = undefined;
  }
  var firstCard = Belt_Option.map(Belt_Option.keep(Category$Showside.getFirstCard(category$1), function (param) {
    return canRenderFirstCard;
  }), function (card) {
    var newrecord = Caml_obj.obj_dup(category$1);
    return React.createElement(CategoryCard$Showside.make, {
      category: (newrecord.card = card, newrecord.showTitle = false, newrecord.description = undefined, newrecord),
      id: "" + category$1.id + "-first-card",
      shape: cardShape,
      showProductCount: false,
      forcedOpenLink: forceOpenLinkFirstCard,
      inspectable: "first-card",
      onClick: isConnectedWithSubCats ? onSmartCardClick : onCategoryClick,
      onImageRendered: onImageRendered,
      key: "" + category$1.id + "-first-card"
    });
  });
  var firstCard$1 = smartCard$1 !== undefined ? smartCard$1 : firstCard !== undefined ? firstCard : undefined;
  var match$4 = Category$Showside.Link.getCardFallbackLink(category$1);
  var lastCardLink = match$4 !== undefined && match$4.TAG === /* URL */0 && (!isConnected || forceOpenLinkLastCard) ? match$4._0 : undefined;
  var onEndCardClick = function (param) {
    if (lastCardLink !== undefined) {
      return Curry.app(trackEvent, ["slider:see all link", true, category$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    } else if (isConnectedWithSubCats) {
      return Curry._1(onSmartCardClick, category$1);
    } else {
      return Curry._1(onCategoryClick, category$1);
    }
  };
  var lastCard;
  if (layout.TAG === /* SliderLayout */0 || !(enableLastCard && (Belt_Option.isSome(lastCardLink) || !forceOpenLinkLastCard))) {
    lastCard = undefined;
  } else {
    var tmp = {
      title: category$1.title,
      shape: cardShape,
      onClick: onEndCardClick,
      key: "" + category$1.id + "-last-card"
    };
    if (lastCardLink !== undefined) {
      tmp.href = Caml_option.valFromOption(lastCardLink);
    }
    lastCard = Caml_option.some(React.createElement(LastCard$Showside.make, tmp));
  }
  return [firstCard$1, lastCard];
}
export { getSmartCard, use };
/* react Not a pure module */